export const Label = ({ image = '', text = '', containerLabel = '', imageLabel = '', textLabel = '' }) => {
  return (
    <div className={containerLabel}>
      <img className={imageLabel} src={image} alt={image} />
      <div className={textLabel}>{text}</div>
    </div>
  )
}
